import {
  baseRequestWithAxiosResponse,
  baseRequestWithHeaders,
} from './base-request';

export const getNetworkProcedures = (centerId) => {
  const url = `network-center/get-procedures-centers-details?centerId=${centerId}`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const updateProcedureDetails = (body) => {
  const url = `network-center/updateProcedureNetworkMap`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const addNewProcedure = (body) => {
  const url = `network-center/addNewProcedure`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const fetchProcedures = () => {
  const url = `practice/get-procedures`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};